// Restricted (c) Siemens Healthineers AG, 2025, All rights reserved.

import { Injectable } from '@angular/core';
import { DnaSyngoviaConnectionRect } from '../../interfaces/dna-syngovia-connection-rect';
import { AbstractChartMapService } from './abstract-chart-map.service';

@Injectable({
  providedIn: 'root',
})
export class ModalityChartMapService extends AbstractChartMapService {
  public override calculateRectValues(
    rects: DnaSyngoviaConnectionRect[],
  ): { row: number; column: number } | void {
    let row = 0;
    let column = this.NUM_OF_COLUMNS - 1;
    rects.forEach((rect) => {
      const type = rect.connection.groupNode.type;

      const widthPadding = this.getWidthPadding(type);

      const x = column * widthPadding;
      const y = this.heightByRow(row, type);

      rect.rect = this.createDOMRectInstance(x, y, type);
      rect.linePath = this.calculateLinePath(rect, row, column);

      column--;
      if (column < 0) {
        column = this.NUM_OF_COLUMNS - 1;
        row++;
      }
    });
  }

  protected override calculateLinePath(
    rect: DnaSyngoviaConnectionRect,
    row: number,
    column: number
  ): string | null {
    const { x, y, width, height } = rect.rect;
    const entrySegment = this.ENTRY_SEGMENT_SMALL;

    const rowFactor = (row + 1) % 2;

    const columnFactor = this.NUM_OF_COLUMNS - column;
    const linePath =
      `M ${x + width * 0.5} ${y + height * rowFactor}` +
      ` l 0 ${entrySegment * (rowFactor ? 1 : -1)}` +
      ` l ${width * (columnFactor - 0.5) + this.PADDING * columnFactor} 0`;

    return linePath;
  }
}
